import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FinancialInformation from '../../components/financial-information/FinancialInformation';
import { useNavigate } from "react-router";

const StepFour = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let productPrice     = useSelector(state => state.productPrice);
    let isShop     = useSelector(state => state.isShop);
    let minThreshold     = useSelector(state => state.minThreshold);
    let maxThreshold     = useSelector(state => state.maxThreshold);

    let navigate = useNavigate();
    const dispatch = useDispatch()

    useEffect(() => {
        if ( !load ) {
            window.scrollTo(0, 0);
            dispatch({ type: 'STEPS_CHANGE', value: 4 })
            // dispatch({ type: 'PRODUCT_PRICE_CHANGE', value: 11 });
            if(typeof window !== "undefined") {
                window.dataLayer.push({'event':'pageview'});
            }
            setLoad(true);
        } 
    }, [load])

    let prev = () => {
        navigate('/krok/3')
    }

    let next = () => {
        navigate('/krok/5')
    }
    
    return (
        <section className="form steps">
            <div className="container-step">
                <div className="row" >
                    <FinancialInformation prev={ () => prev() } next={ () => next() } />
                </div>
            </div>
        </section>
    )
}

export default StepFour;